import { useEffect, useState } from "react";
import Link from "next/link";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  fetchCities,
  fetchCityEvents,
  fetchSliders,
  checkFollowedCities,
  followCity,
  unfollowCity,
  showAppModal,
} from "redux/actions/app";

import { Progress } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import UserLink from "components/user/UserLink";
import UserAvatar from "components/user/UserAvatar";
import CityTags from "components/cities/CityTags";
import SiteLayout from "components/layout/SiteLayout";
import CitySwiper from "components/cities/CitySwiper";
import CityJoinBtn from "components/cities/CityJoinBtn";

import { timeAgo } from "utils/app";
import moment from "moment";
import { postUrl, getHref } from "utils/route";
import { userUrl } from "utils/route";
import { PlusOutlined } from "@ant-design/icons";

const Page = ({
  cities: citiesProp,
  cityEvents,
  sliders,
  token,
  checkFollowedCities,
  currentUser,
}: any) => {
  const shouldScroll = true;
  const [cities, setCities] = useState(citiesProp);

  const fillArray = (arr: any) => {
    const targetLength = 8;
    while (arr.length < targetLength && arr.length > 4) {
      const copiedElements = arr.slice(0, targetLength - arr.length);
      arr = arr.concat(copiedElements);
    }
    arr = arr.slice(0, targetLength);
    return arr;
  };

  const events: any = {
    group_create: "创建了群",
    group_join: "加入了城市分舵",
    city_follow: "关注了城市",
    comment_create: "发布了评论",
    job_apply: "申请了工作",
    activity: "参加了活动",
    post_create: "发布了帖子",
  };

  const indexColors: any = {
    1: "#F65D5D",
    2: "#F97D48",
    3: "#F9BA48",
    4: "#44A2E6",
    5: "#45D05C",
  };

  const more = (city: any) => {
    return (
      <Link
        legacyBehavior
        as={`/cities/${city.id}`}
        href="/cities/[id]"
      >
        <a target="_blank">
          <div className="more-users"></div>
        </a>
      </Link>
    );
  };

  useEffect(() => {
    if (token) {
      checkFollowedCities(token);
    }
  }, [token]);
  return (
    <SiteLayout
      pageTitle="城市"
      largeContainer
    >
      <div className="cities-container">
        <CitySwiper images={sliders} />
        <div className="small-container">
          {cityEvents && cityEvents.length > 0 && (
            <Swiper
              className="event-swiper"
              modules={[Autoplay]}
              slidesPerView={4}
              spaceBetween={10}
              direction={"vertical"}
              simulateTouch={false}
              autoplay={
                shouldScroll && {
                  delay: 2000,
                  pauseOnMouseEnter: true,
                  disableOnInteraction: false,
                }
              }
              loop={true}
            >
              {fillArray(cityEvents).map((cityEvent: any) => (
                <SwiperSlide key={cityEvent.id}>
                  <div className="event-item">
                    <div className="left">
                      <img src={`static/icons/${cityEvent.kind}.png`} />
                      <Link
                        legacyBehavior
                        href="/users/[id]"
                        as={userUrl(cityEvent.user, currentUser)}
                      >
                        <a
                          target="_blank"
                          className="yellow title nickname"
                        >
                          {cityEvent.user.nickname}
                        </a>
                      </Link>
                      <span>{events[cityEvent.kind]}</span>

                      {["job_apply", "post_create", "comment_create"].includes(
                        cityEvent.kind
                      ) && (
                        <Link
                          legacyBehavior
                          href={getHref(cityEvent.details.post)}
                          as={postUrl(cityEvent.details.post)}
                        >
                          <a
                            className="yellow title"
                            target="_blank"
                          >
                            {cityEvent.details.post.title}
                          </a>
                        </Link>
                      )}
                      {["city_follow"].includes(cityEvent.kind) && (
                        <span
                          className="yellow title"
                          onClick={() =>
                            window.open(
                              `/cities/${cityEvent.city.id}`,
                              "_blank"
                            )
                          }
                        >
                          {cityEvent.city.name}
                        </span>
                      )}
                      {["group_create", "group_join"].includes(
                        cityEvent.kind
                      ) && (
                        <Link
                          href={`/groups/${cityEvent.details.group.id}`}
                          className="text-primary"
                        >
                          {cityEvent.details.group.name}
                        </Link>
                      )}
                    </div>
                    <div className="right">
                      {timeAgo(cityEvent.happened_at)}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          <div className="create-city-block">
            <div className="all-city-text">全部城市</div>
            <div
              className="sm-create-city-btn"
              onClick={() =>
                window.open("https://eleduck.com/posts/oQfVaa", "_blank")
              }
            >
              <PlusOutlined /> <div>创建城市</div>
            </div>
          </div>
          {cities &&
            cities.map((city: any, index: number) => (
              <div
                key={city.id}
                className={`city-wrapper ${
                  index % 2 !== 0 && "city-wrapper-reverse"
                }`}
              >
                <Link
                  legacyBehavior
                  as={`/cities/${city.id}`}
                  href="/cities/[id]"
                >
                  <a
                    target="_blank"
                    className="left"
                  >
                    <div>
                      <img
                        className="cover"
                        src={city.cover.url}
                      />
                      <CityTags
                        city={city}
                        className="hide-in-mp"
                      />
                    </div>
                  </a>
                </Link>
                <div className="right">
                  <div className="city-info">
                    <div className="left-info">
                      <div
                        className="city-name"
                        onClick={() =>
                          window.open(`/cities/${city.id}`, "_blank")
                        }
                      >
                        {city.name}
                      </div>
                      <CityJoinBtn
                        city={city}
                        refresh={() =>
                          fetchCities().then((res) => {
                            setCities(res);
                          })
                        }
                      />
                    </div>
                    <div className="owner-info">
                      <UserAvatar
                        user={city.owner}
                        size={undefined}
                      />
                      <UserLink user={city.owner} />
                      <div className="date">
                        {moment(city.created_at).format("YYYY-MM-DD")}创建
                      </div>
                    </div>
                  </div>
                  <div className="followed-users">
                    <div className="mp-users">
                      {city.followed_users.slice(0, 5).map((user: any) => (
                        <UserAvatar
                          size={20}
                          user={user}
                          key={user.id}
                        />
                      ))}
                      {city.followed_users.length > 5 && more(city)}
                      <div className="total-count">
                        <span>{city.followed_count}</span>个居民
                      </div>
                    </div>
                    <div className="pc-users">
                      {city.followed_users.slice(0, 19).map((user: any) => (
                        <UserAvatar
                          size={44}
                          user={user}
                          key={user.id}
                        />
                      ))}
                      {city.followed_users.length > 19 && more(city)}
                      <div className="total-count">
                        <span>{city.followed_count}</span>个居民
                      </div>
                    </div>
                  </div>
                  <div className="city-indexes">
                    {Object.entries(city.indexes).map(
                      ([indexName, indexValue]: any) => (
                        <div
                          key={indexName}
                          className="index"
                        >
                          <span>{indexName}</span>
                          <Progress
                            showInfo={false}
                            percent={indexValue / 0.05}
                            steps={5}
                            strokeColor={indexColors[indexValue]}
                          />
                        </div>
                      )
                    )}
                  </div>
                  <div className="line"></div>
                  <CityTags
                    city={city}
                    className="hide-in-pc"
                  />
                </div>
              </div>
            ))}
          <div
            className="create-city-btn"
            onClick={() =>
              window.open("https://eleduck.com/posts/oQfVaa", "_blank")
            }
          >
            <div>没有你所在城市？</div>
            <div className="text">我来创建&nbsp;</div>
            <div className="create-icon"></div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};
const mapStateToProps = (state: any) => ({
  currentUser: state.user.user,
  token: state.user.token,
  followedCities: state.app.followedCities,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    { checkFollowedCities, unfollowCity, followCity, showAppModal },
    dispatch
  );

Page.getInitialProps = async (ctx: any) => {
  const { store } = ctx;

  const cities = await fetchCities(store.getState().user.token);
  const cityEvents = await fetchCityEvents();
  const sliders = await fetchSliders({
    kind: "city",
    listed: true,
    city_id: "",
  });

  return {
    cities,
    cityEvents,
    sliders,
  } as any;
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
